export default "__VITE_ASSET__CCC99kMb__"